// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"numbers-3"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M8 19H15C15.5523 19 16 18.5523 16 18V12M8 5H15C15.5523 5 16 5.44772 16 6V12M16 12H9","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Numbers3Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'numbers-3',
    ref,
    icon: element,
  },
));

Numbers3Icon.displayName = 'Numbers3Icon';

export default Numbers3Icon;
